module.exports = __webpack_public_path__ + "static/img/logo1.7aa36e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo1.jpg
// module id = 9gXQ
// module chunks = 3